module.exports = __webpack_public_path__ + "static/media/longhash.4dde1f48.png";